module.exports = __webpack_public_path__ + "img/inisiasi.2a6deb09.jpg";